// src/store/baseQuery.ts
import { fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import type { BaseQueryFn, FetchArgs, FetchBaseQueryError } from "@reduxjs/toolkit/query";
import { apiBaseUrl } from "../utils/constants";

const baseQuery = fetchBaseQuery({
  baseUrl: apiBaseUrl,
  prepareHeaders: (headers) => {
    headers.set("Accept", "application/json");
    headers.set("ngrok-skip-browser-warning", "test");
    const token = localStorage.getItem("authToken");
    const role = localStorage.getItem("userRole");
    if (role) headers.set("X-User-Type", role);
    if (token) headers.set("Authorization", `Bearer ${token}`);
    return headers;
  },
});

export const baseQueryWithLogout: BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError> = async (args, api, extraOptions) => {
  const result: any = await baseQuery(args, api, extraOptions);

  // Handle 401 responses globally
  if (result.error && result.error.status === 401) {
    localStorage.clear();

    window.dispatchEvent(
      new CustomEvent("auth:logout", {
        detail: { reason: "session_expired" },
      })
    );
    if (!result.meta.request.url.includes("new_logins_odata")) {
      window.location.replace("/login");
    }
  }

  return result;
};

export const createApiBaseQuery = (baseUrl?: string) => {
  const customBaseQuery = fetchBaseQuery({
    baseUrl: baseUrl || apiBaseUrl,
    prepareHeaders: (headers) => {
      headers.set("Accept", "application/json");
      headers.set("ngrok-skip-browser-warning", "test");
      const token = localStorage.getItem("authToken");
      const role = localStorage.getItem("userRole");
      if (role) headers.set("X-User-Type", role);
      if (token) headers.set("Authorization", `Bearer ${token}`);
      return headers;
    },
  });

  const customBaseQueryWithLogout: BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError> = async (args, api, extraOptions) => {
    const result = await customBaseQuery(args, api, extraOptions);

    if (result.error && result.error.status === 401) {
      localStorage.clear();
      // document.body.classList.remove("Login");
      console.warn("Session expired. Please login again.");
      // window.location.href = "/login";
      window.location.replace("/login");
    }

    return result;
  };

  return customBaseQueryWithLogout;
};

const baseCaptchaQuery = fetchBaseQuery({
  baseUrl: apiBaseUrl,
  prepareHeaders: (headers) => {
    headers.set("Accept", "application/json");
    headers.set("ngrok-skip-browser-warning", "test");
    return headers;
  },
});

export const baseCaptchaQueryWithLogout: BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError> = async (args, api, extraOptions) => {
  const result = await baseCaptchaQuery(args, api, extraOptions);

  return result;
};

const baseEmpData = fetchBaseQuery({
  baseUrl: "https://employee.erpcwc.com",
  prepareHeaders: (headers) => {
    const username = "CWC_USER";
    const password = "r8QssJr<^W25";
    const token = btoa(`${username}:${password}`);
    headers.set("Authorization", `Basic ${token}`);
    return headers;
  },
});

export const baseEmpDataQuery: BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError> = async (args, api, extraOptions) => {
  const result = await baseEmpData(args, api, extraOptions);

  return result;
};
